<ng-container>
  <div class="field-container">
    <div class="flex items-center gap-1">
      <p-checkbox inputId="{{checkboxId}}" [binary]="true" [ngModel]="value" [disabled]="disabled" autocomplete="off"
        (onChange)="changeCheckBox($event)" />
      <label class="label-checkbox" for="{{checkboxId}}">{{labelText}}</label>
    </div>
  </div>
</ng-container>